// @flow
import {
	ProductListSlider,
	EshopPhotogallery,
	EshopModel3D,
	EshopImageMagnify,
	EshopGalleryPopup,
	EshopOrderForm,
} from 'fg-frontend';

import EshopVariantStockHandler from 'fg-frontend/src/components/EshopVariantStockHandler';

export default (props) => {
	switch (props.decorator || props.is) {
		case 'EshopPhotogallery':
			return EshopPhotogallery;
		case 'EshopModel3D':
			return EshopModel3D;
		case 'EshopImageMagnify':
			return EshopImageMagnify;
		case 'EshopGalleryPopup':
			return EshopGalleryPopup;
		case 'EshopOrderForm':
			return EshopOrderForm;
    case 'ProductListSlider':
      return ProductListSlider;
		case 'EshopVariantStockHandler':
			return EshopVariantStockHandler;
	}
};



// WEBPACK FOOTER //
// ./fe/web-eshop/src/js/configureEshopComponents.js